import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'ymdDate'
})
export class YmdDatePipe implements PipeTransform {

  transform(val: any): any {
      let num;
      if (val && val != 0) {
          const value = val.toString();
          if (value.length < 4) {
              num = ' ';
              return num;
          } else if (value.length == 4) {
              num = value.slice(2, 4) + '/' + value.slice(0, 2);
              return num;
          } else {
              num = value.slice(4, 6) + '/' + value.slice(6, 8) + '/' + value.slice(0, 4);
              return num;
          }

      } else {
          return;
      }
  }

}
